// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonNouns = {
  time: "時間",
  operator: "操作ユーザー",
  staff: "試験運営スタッフ",
  candidate: "受験者",
  user: "ユーザー",
  paper: "試験用紙",
  question: "問題",
  exam: "試験",
  attempt: "受験",
  status: "状態",
  role: "ロール",
  type: "種別",
  description: "説明",
  codeSnapshot: "コードスナップショット",
  actions: "操作",
} as const;
